export const PERSONAL_INFO = "PERSONAL_INFO";
export const EDUCATION = "EDUCATION";
export const PROFESSIONAL_EXPERIENCE = "PROFESSIONAL_EXPERIENCE";
export const SKILLS = "SKILLS";
export const PROFESSIONAL_SUMMARY = "PROFESSIONAL_SUMMARY";
export const CERTIFICATES = "CERTIFICATES";
export const SELECT_PROFILE = "SELECT_PROFILE";